/* eslint-disable complexity */
/* eslint-disable no-debugger */
/* eslint-disable max-statements */
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
// import ReactPaginate from "react-js-pagination";
import {  CURRENCY, FILTER_ENTITIES, LISTING_TYPE, NUMBER } from "../../../constants/app-constants";
import Filters from "../../../utils/filters-v2";
import styles from "./styles.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { useHistory } from "react-router";
import { API_VERSION_V2 } from "../../../service/api-version";
import debounce from "../../../utils/helpers/debounce";
// import parseCookie from "../../../utils/helpers/parse-cookie";
// import saveCookie from "../../../utils/helpers/save-cookie";
import getUpdatedAppliedFilters from "../../../utils/filters-v2/get-updated-applied-filters";
import { getRecentSearch, updateSearchList } from "../../shared/global-search-au/selectors";
import { APPLIED_FILTER_META } from "../../../utils/filters-v2/constants";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import useStyleInjection from "../../../hooks/use-style-injection";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { DEFAULT_PATHNAME } from "../../../utils/filters-v2/constants";
import { appUrl } from "../../../constants/url-constants";

import SearchSuggestions from "./search-suggestions/component";
import FilterPillsSection from "./filter-pills/component";
import SearchInput from "./search-input/component";

const CUSTOM_SELECT_FILTER_PILL_NAMES = {
    TEST_DRIVE: "Test Drive",
    SALE: "EOFY Sale",
    CAR_TOUR: "CarTour"
};

const AU_LISTING_PATH = "/buy-used-cars-australia";

const getSuggestionListingUrl = ({ query, seoOptimalUrl, value, label } = {}) => {
    if (seoOptimalUrl) {
        return new window.URL(seoOptimalUrl, appUrl()).href;
    }

    let queryFilters = [];
    if (Array.isArray(query)) {
        queryFilters = query;
    } else if (query) {
        queryFilters = [query];
    }
    const filterQuery = queryFilters.map(filter => `f=${encodeURIComponent(filter)}`).join("&");
    const searchTerm = value || label;
    const queryString = filterQuery || `search=${encodeURIComponent(searchTerm)}`;

    return `${appUrl()}${AU_LISTING_PATH}?${queryString}`;
};

const SearchRevamp = ({
    secureToken = "",
    fetchAutoSuggestionsConnect,
    updateFilterOptionDataConnect,
    fetchSearchResultConnect,
    searchPageResult,
    selectedCity = {},
    allFilters,
    selectedFilters,
    clearAllFiltersConnect,
    updateUrlOptionsConnect,
    reloadCarListConnect,
    urlOptions,
    appliedFilters,
    updateSelectedSuggestionsConnect,
    updateListingTypeConnect,
    updateAppliedFiltersConnect,
    email,
    clearSelectedFilterConnect,
    isHomePage = false,
    totalAvailableCars,
    saleConfig = {},
    webPriceDropDesktop,
    userGeoData,
    isHeader,
    showSearchInput = true
}) => {
    const history = useHistory();
    const isFromHomePage = (history.location.state || {}).isFromHomePage;
    const searchRef = useRef();
    const suggestionRequestRef = useRef(0);
    const { code: selectedCityCode } = selectedCity || {};
    const [searchInput, setSearchInput] = useState(urlOptions.search);
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const [noResult, setNoResult] = useState(false);
    const { saleLive } = saleConfig?.data || {};
    const [searchSection, showSearchSection] = useState(false);
    const [showAllSelectedFilter, setShowAllSelectedFilter] = useState(false);
    const [isSearchSubmitted, setIsSearchSubmitted] = useState(false);
    const { popularSearchFilters = [] } = searchPageResult || {};
    const inputSearchValue = searchInput || urlOptions.search;
    const recentSearched = getRecentSearch() || [];

    const showWebPriceDesktop = getAbExpirementVariant(webPriceDropDesktop, EXPERIMENT_TYPE.VARIANT_B);
    const HIDDEN_FILTERS = [FILTER_ENTITIES.GEO_LOCATION, ...(showWebPriceDesktop  && [FILTER_ENTITIES.GREAT_DEALS])];
    const { getOrCreateRef, injectStyles } = useStyleInjection();
    const { coordinates } = userGeoData || {};
    // Memoized values
    // const searchSuggestionsLabels = useMemo(() =>
    //     searchSuggestions.length > 0 ? searchSuggestions.map(item => item?.label) : [],
    // [searchSuggestions]
    // );

    const selectedFiltersModified = useMemo(() => selectedFilters.filter((item) => !HIDDEN_FILTERS.includes(item.filterKey)),
        [HIDDEN_FILTERS, selectedFilters]);

    const selectedFilterPills = useMemo(() =>
        showAllSelectedFilter ? selectedFiltersModified : selectedFiltersModified.slice(0, NUMBER.SIX),
    [selectedFiltersModified, showAllSelectedFilter]
    );

    const popularSearch = useMemo(() =>
        (popularSearchFilters || {}).result || [],
    [popularSearchFilters]
    );

    const modifiedSearch = useMemo(() =>
        recentSearched && recentSearched.slice(0, NUMBER.SIX),
    [recentSearched]
    );

    useEffect(() => {
        if (isHomePage) {
            showSearchSection(false);
            setSearchInput("");
            updateUrlOptionsConnect({ search: "" });
        }
    }, [isHomePage, updateUrlOptionsConnect]);

    useEffect(() => {
        fetchSearchResultConnect();
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.NEW_SEARCH_SECTIONS_VISIBLE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureToken, coordinates]);

    const handleClickOutside = useCallback((event) => {
        if (searchRef.current && !searchRef.current.contains(event.target)) {
            showSearchSection(false);
        }
    }, []);

    useEffect(() => {
        if (!(searchSection && !isSearchSubmitted)) {
            return () => {};
        }
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchSection, isSearchSubmitted ]);

    const getSelectedFilterTag = useCallback(({ filterKey, isRangeFilter, displayText, optionKey, subOptionKey, min, max, displayName }) => {
        const displayTag = `${optionKey} ${subOptionKey || ""}`;
        const suffix = APPLIED_FILTER_META[filterKey] && APPLIED_FILTER_META[filterKey].suffix;
        const prefix = APPLIED_FILTER_META[filterKey] && APPLIED_FILTER_META[filterKey].prefix;

        let displayMin = min;
        let displayMax = max;

        if (prefix === CURRENCY.AU || suffix === "KMs") {
            displayMin = priceFormatter(min, true, CURRENCY.AU);
            displayMax = priceFormatter(max, true, CURRENCY.AU);
        }

        if (filterKey === "imperfectionCount") {
            return `Imperfections: ${displayTag}`;
        } else if (filterKey === FILTER_ENTITIES.SEATS) {
            return `${displayTag} Seats`;
        } else if (filterKey === FILTER_ENTITIES.SAFETYANDQUALITY) {
            return `ANCAP: ${displayTag}`;
        } else if (filterKey === FILTER_ENTITIES.TEST_DRIVE) {
            return CUSTOM_SELECT_FILTER_PILL_NAMES.TEST_DRIVE;
        } else if (filterKey === FILTER_ENTITIES.DISTANCE) {
            return `${displayMax} kms away from your location`;
        } else if (isRangeFilter) {
            return displayText ? displayText :
        `${prefix ? `${prefix} ` : ``}${displayMin}${suffix ? ` ${suffix}` : ``} - ${prefix ? `${prefix} ` : ``}${displayMax}${suffix ? ` ${suffix}` : ``}`;
        } else if (filterKey === FILTER_ENTITIES.GREAT_DEALS) {
            const text = displayText.split("_").join(" ");
            return text;
        } else if (filterKey === FILTER_ENTITIES.PROMOTION) {
            return CUSTOM_SELECT_FILTER_PILL_NAMES.SALE;
        } else if (filterKey === FILTER_ENTITIES.CAR_TOUR) {
            return CUSTOM_SELECT_FILTER_PILL_NAMES.CAR_TOUR;
        } else if (filterKey === FILTER_ENTITIES.SELLER_TYPE) {
            return displayName || displayText;
        }
        return displayTag;
    }, []);

    const triggerSuggestionGAEvent = useCallback((inputValue, suggestions) => {
        const eventLabel = suggestions.map(item => item?.label).join();
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTERS_SEARCH_BRANDS, {
            eventLabel: `${inputValue}: ${eventLabel.length === 0 ? "No result" : eventLabel}`
        });
    }, []);

    const getOptions = useCallback((inputValue) => {
        const requestId = ++suggestionRequestRef.current;
        if (!isSearchSubmitted) {
            showSearchSection(true);
        }
        const payload = { search: inputValue, showAutoSuggestionVariant: true };
        showSearchSection(true);

        fetchAutoSuggestionsConnect(payload, API_VERSION_V2).then(response => {
            if (requestId !== suggestionRequestRef.current) return;

            const suggestions = Array.isArray(response) ? response.map(item => ({
                ...item,
                label: item.displayTitle,
                value: item.displayTitle,
                query: item.query
            })) : [];
            triggerSuggestionGAEvent(inputValue, suggestions);

            if (!isSearchSubmitted) {
                setSearchSuggestions(suggestions);
                if (suggestions.length > 0) {
                    setNoResult(false);
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE_SEARCH_AUTO_SUGGESTION_VISIBLE, {
                        eventLabel: suggestions.map(item => item?.label)
                    });
                } else {
                    setNoResult(true);
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE, {
                        eventAction: "auto_suggestion_no_result",
                        eventLabel: inputValue
                    });
                }
            }
        });
    }, [fetchAutoSuggestionsConnect, isSearchSubmitted, triggerSuggestionGAEvent]);

    const delayedQuery = useMemo(() =>
        debounce((val) => {
            getOptions(val);
        }, NUMBER.THREE_HUNDRED),
    [getOptions]
    );

    useEffect(() => {
        if (urlOptions.search && !isHomePage && !isFromHomePage) {
            delayedQuery(urlOptions.search);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const clearInput = useCallback(async () => {
        setSearchInput("");
        setNoResult(false);
        setSearchSuggestions([]);
        await yieldToMain();
        updateFilterOptionDataConnect([]);
        updateUrlOptionsConnect({ search: "" });
        reloadCarListConnect(true);

    }, [reloadCarListConnect, updateFilterOptionDataConnect, updateUrlOptionsConnect]);

    const clearAllFilters = useCallback(() => {
    // inject dynamic styles to element with id=clearAllFilters
        const el = document.getElementById("clearAllFilters");
        if (el) {
            el.style.opacity = "0.7";
            void el.offsetHeight;
        }
        clearAllFiltersConnect();
        clearInput();
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_CLEAR_ALL_FILTERS_SELECTED);
    }, [clearAllFiltersConnect, clearInput]);

    // eslint-disable-next-line max-params
    const onSearchClickHandler = useCallback(async (selectedValue, searchCategory, isFreeText, position) => {
        const isSuggestionClick = searchCategory === "modalSearch";
        const { value = "", type = "", label = "", filterId } = selectedValue || {};
        let listingUrl;

        if (isSuggestionClick) {
            listingUrl = getSuggestionListingUrl(selectedValue);
        } else {
            setIsSearchSubmitted(true);
            const currentFilters = new Filters({ cityCode: selectedCityCode });
            const { relativeURL } = currentFilters.getListingPayload({
                selectedFilters,
                filters: allFilters,
                ...(value && {
                    options: {
                        ...urlOptions,
                        search: value,
                        ...(filterId && { filterId })
                    }
                })
            });
            listingUrl = `${appUrl()}${relativeURL}`;

            updateSearchList(selectedValue);
            showSearchSection(false);
            setSearchInput(value);
            await yieldToMain();

            updateListingTypeConnect(LISTING_TYPE.SEARCH);
            clearAllFiltersConnect();
            updateUrlOptionsConnect({ search: value, ...(filterId && { filterId }) });
            reloadCarListConnect(true);

            window.setTimeout(() => window.scrollTo(0, 0));
        }

        const category = type === "Make"
            ? AU_DESKTOP_EVENTS.FILTERS_SEARCH_SUGGESTED_BRANDS
            : AU_DESKTOP_EVENTS.FILTERS_SEARCH_SUGGESTED_MODELS;

        trackDesktopCustomEventsAU(category, { eventLabel: `options ${label || value}` });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_SEARCH, {
            search_term: value,
            user_id: email
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE, {
            eventAction: "search_text",
            eventLabel: value
        });

        if (searchCategory === "recent") {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE_RECENTLY_SEARCHED, {
                eventLabel: `${selectedValue.value}`
            });
            if (isHomePage) {
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SEARCH_SUGGESTION_CLICKED, {
                    eventLabel: `Recent Search ${selectedValue.value}`
                });
            }
        } else if (searchCategory === "popular") {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE_POPULAR_SEARCH, {
                eventLabel: `${selectedValue.value}`
            });
        } else if (!isFreeText) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE_SEARCH_AUTO_SUGGESTION_APPLIED, {
                eventLabel: `${selectedValue.value} | ${position + 1}`
            });
            if (isHomePage) {
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SEARCH_SUGGESTION_CLICKED, {
                    eventLabel: `Search Suggestion ${selectedValue.value}`
                });
            }
        }

        window.location.href = listingUrl;
    }, [allFilters, clearAllFiltersConnect, email, isHomePage, reloadCarListConnect, selectedCityCode, selectedFilters, updateListingTypeConnect, updateUrlOptionsConnect, urlOptions]);

    const handleInputChange = useCallback((event) => {
        const searchInputValue = event.target.value.replace("=", "");
        // Reset the submission flag whenever user types
        setIsSearchSubmitted(false);

        if (searchInputValue.length > 0) {
            setSearchInput(searchInputValue);
            setSearchSuggestions([]);
            delayedQuery(searchInputValue);
        } else {
            clearInput();
        }
    }, [clearInput, delayedQuery]);

    const onRemoveFilter = useCallback(async (item) => {
        const cleanup = injectStyles(`remove-filter-${item?.filterKey}`);
        if (item.filterKey === FILTER_ENTITIES.MODELCITYNAME) {
            clearAllFilters();
      // eslint-disable-next-line no-unused-expressions
      cleanup?.();
      return;
        }

        const { filterKey, optionKey, subOptionKey, min, max } = item || {};
        const data = {
            filterKey,
            optionKey,
            subOptionKey,
            isSelected: false,
            ...(min && { min }),
            ...(max && { max })
        };

        if (filterKey === FILTER_ENTITIES.DISTANCE) {
            updateFilterOptionDataConnect({
                filterKey: FILTER_ENTITIES.GEO_LOCATION
            });
        }
        updateFilterOptionDataConnect(data);
        updateAppliedFiltersConnect();
        reloadCarListConnect(true);
        await yieldToMain();

        const updatedFilters = getUpdatedAppliedFilters(data, appliedFilters);
        if (updatedFilters.length === NUMBER.ONE) {
            if (updatedFilters[0].filterKey === FILTER_ENTITIES.MODELCITYNAME) {
                updatedFilters[0].filterKey = FILTER_ENTITIES.MAKE;
            }
        }

        const filters = new Filters({ cityCode: "" });
        const { relativeURL } = filters.getListingPayload({
            selectedFilters: updatedFilters,
            filters: allFilters,
            ...(urlOptions.search && item.type !== "search" && { options: { search: urlOptions.search } })
        });

        if (item.type === "search") {
            updateUrlOptionsConnect({ search: "" });
        }

        if (optionKey) {
            clearSelectedFilterConnect(optionKey.toLowerCase());
        }

        updateSelectedSuggestionsConnect(data);
        window.location.href = `${appUrl()}${relativeURL}`;
    }, [allFilters, appliedFilters, clearAllFilters, clearSelectedFilterConnect, injectStyles, reloadCarListConnect, updateAppliedFiltersConnect, updateFilterOptionDataConnect, updateSelectedSuggestionsConnect, updateUrlOptionsConnect, urlOptions.search]);

    const handleFocus = useCallback(() => {
        if (!isSearchSubmitted) {
            showSearchSection(true);
        }
        if (isHomePage) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SEARCH_BAR_CLICKED, {
                eventLabel: ""
            });
        }
    }, [isSearchSubmitted, isHomePage]);

    const handleShowAllSelectedFilter = useCallback(() => {
        setShowAllSelectedFilter(prevState => !prevState);
    }, []);

    const handleOnKeyDown = useCallback((event) => {
        if ((event.keyCode === NUMBER.THIRTEEN || event.which === NUMBER.THIRTEEN) && searchInput && searchInput.trim() !== "") {
            event.preventDefault();
            const firstSuggestion = searchSuggestions[0];

            if (firstSuggestion) {
                onSearchClickHandler(firstSuggestion, "modalSearch", false, 0);
            }
        }
    }, [onSearchClickHandler, searchInput, searchSuggestions]);

    const onShowButtonClickHandler = useCallback(() => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.VIEW_ALL_CTA_CLICKED, {
            eventLabel: ""
        });
        window.location.href = `${appUrl()}${DEFAULT_PATHNAME}`;
    }, []);

    const searchWrapperStyle = isHomePage ? "styles.homeSearchWrapper" : "styles.searchWrapper";
    return (
        <React.Fragment>
            <div className="col-12" styleName={`styles.outer ${!(selectedFilterPills || []).length ? "styles.outerMargin" : ""}`} ref={searchRef}>
                {showSearchInput && <div styleName={`${searchWrapperStyle} ${isHeader ? "styles.headerSearchWrapper" : ""}`}>
                    <SearchInput
                        isHomePage={isHomePage}
                        inputSearchValue={inputSearchValue}
                        handleInputChange={handleInputChange}
                        handleFocus={handleFocus}
                        handleOnKeyDown={handleOnKeyDown}
                        totalAvailableCars={totalAvailableCars}
                        onShowButtonClickHandler={onShowButtonClickHandler}
                    />

                    {searchSection && !isSearchSubmitted && (
                        <SearchSuggestions
                            isHomePage={isHomePage}
                            inputSearchValue={inputSearchValue}
                            modifiedSearch={modifiedSearch}
                            popularSearch={popularSearch}
                            searchSuggestions={searchSuggestions}
                            noResult={noResult}
                            onSearchClickHandler={onSearchClickHandler}
                        />
                    )}
                </div>}

                {selectedFilterPills.length > 0 && !isHomePage && !isHeader && (
                    <FilterPillsSection
                        selectedFilterPills={selectedFilterPills}
                        selectedFiltersModified={selectedFiltersModified}
                        getSelectedFilterTag={getSelectedFilterTag}
                        onRemoveFilter={onRemoveFilter}
                        handleShowAllSelectedFilter={handleShowAllSelectedFilter}
                        showAllSelectedFilter={showAllSelectedFilter}
                        getOrCreateRef={getOrCreateRef}
                        saleLive={saleLive}
                        FILTER_ENTITIES={FILTER_ENTITIES}
                        clearAllFilters={clearAllFilters}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

SearchRevamp.propTypes = {
    secureToken: PropTypes.string,
    fetchAutoSuggestionsConnect: PropTypes.func,
    updateFilterOptionDataConnect: PropTypes.func,
    fetchSearchResultConnect: PropTypes.func,
    searchPageResult: PropTypes.object,
    selectedCity: PropTypes.object,
    allFilters: PropTypes.object,
    selectedFilters: PropTypes.array,
    clearAllFiltersConnect: PropTypes.func,
    updateUrlOptionsConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    urlOptions: PropTypes.object,
    appliedFilters: PropTypes.array,
    updateSelectedSuggestionsConnect: PropTypes.func,
    updateListingTypeConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    email: PropTypes.string,
    clearSelectedFilterConnect: PropTypes.func,
    isHomePage: PropTypes.bool,
    totalAvailableCars: PropTypes.number,
    saleConfig: PropTypes.object,
    webPriceDropDesktop: PropTypes.object,
    userGeoData: PropTypes.object,
    isHeader: PropTypes.bool,
    showSearchInput: PropTypes.bool
};

export default SearchRevamp;
